import { render, staticRenderFns } from "./chatRecordSearch.vue?vue&type=template&id=1a2e36ba&scoped=true&"
import script from "./chatRecordSearch.vue?vue&type=script&lang=js&"
export * from "./chatRecordSearch.vue?vue&type=script&lang=js&"
import style0 from "./chatRecordSearch.vue?vue&type=style&index=0&id=1a2e36ba&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e36ba",
  null
  
)

export default component.exports